import { createReducer } from '@reduxjs/toolkit';

import { noop } from '@constants/general';
import allReducers from '@store/allReducers';

import { RESET } from './root.const';

const initialState = {};

const rootReducer = createReducer(initialState, builder => {
  builder.addCase(RESET, () => initialState).addDefaultCase(noop);
});

export default (state = initialState, action) => {
  const newState = rootReducer(state, action);
  return allReducers(newState, action);
};
